module.exports = __webpack_public_path__ + "img/edit.png";